export default function FormModal({ title, onClose, onSubmit, loading, children, size = '' }) {
  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className={`modal-dialog modal-dialog-centered ${size}`}>
        <div className="modal-content">
          <div className="modal-header py-2">
            <h6 className="modal-title">{title}</h6>
            <button type="button" className="btn-close btn-close-sm" onClick={onClose} disabled={loading} />
          </div>
          <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
            <div className="modal-body">
              {children}
            </div>
            <div className="modal-footer py-1">
              <button type="button" className="btn btn-sm btn-secondary" onClick={onClose} disabled={loading}>
                Cancel
              </button>
              <button type="submit" className="btn btn-sm btn-primary" disabled={loading}>
                {loading ? 'Saving...' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
